import { type Nullable, type UNSAFE_any } from '@flecto/types'

const globalWindow: Nullable<UNSAFE_any> =
  typeof window !== 'undefined' ? window : null

if (globalWindow && !globalWindow.FLECTO_ANALYTICS) {
  globalWindow.FLECTO_ANALYTICS = []
}

function decorator(fn: (...args: UNSAFE_any[]) => UNSAFE_any) {
  return (...args: UNSAFE_any[]) => {
    if (localStorage.getItem('flecto-debug')) {
      globalWindow?.FLECTO_ANALYTICS?.push({
        data: args,
        meta: {
          time: Date.now(),
          type: fn.name,
        },
      })
      const arrayOfItemsChangeEvent = new Event('analyticsChange')
      window.dispatchEvent(arrayOfItemsChangeEvent)
    }
    fn(...args)
  }
}

function trackWithGtmFn(event: string, args: unknown) {
  try {
    if (typeof window === 'undefined') return
    ;(window as UNSAFE_any)?.dataLayer?.push(event, args)
  } catch (err) {
    console.error(err)
  }
}

function trackWithSegmentFn(event: string, args: unknown) {
  try {
    if (typeof window === 'undefined') return
    ;(window as UNSAFE_any)?.analytics?.track(event, args)
  } catch (err) {
    console.error(err)
  }
}

function identifyAnalyticsUserFn(data: unknown) {
  try {
    if (typeof window === 'undefined') return

    if (!window?.analytics?.hasIdentified)
      return (window as UNSAFE_any)?.analytics?.identify(data)

    window.analytics.hasIdentified = true
  } catch (err) {
    console.error(err)
  }
}

export const trackWithGtm = decorator(trackWithGtmFn)
export const trackWithSegment = decorator(trackWithSegmentFn)
export const identifyAnalyticsUser = decorator(identifyAnalyticsUserFn)
